(function () {
  var syncing = false;
  var pendingSync = false;
  var syncTimer = null;
  var cartPayloadSyncTimer = null;
  var requestCooldownUntil = 0;
  var suppressRefreshSyncUntil = 0;
  var fallbackRetryCount = 0;
  var verifyRetryCount = 0;
  var lastFallbackSyncAt = 0;
  var observedGiftRootCount = 0;
  var watchingGiftConfigRoots = false;

  function now() {
    return Date.now();
  }

  function debug() {
    if (!window.console || !window.console.info) return;
    window.console.info.apply(window.console, ['[cart-free-gift]'].concat(Array.prototype.slice.call(arguments)));
  }

  function getConfig() {
    var roots = Array.prototype.slice.call(document.querySelectorAll('[data-cart-free-gift]'));
    if (roots.length === 0) return null;

    for (var i = 0; i < roots.length; i++) {
      var rawGifts = roots[i].getAttribute('data-gifts') || '[]';
      var gifts = [];

      try {
        gifts = JSON.parse(rawGifts);
      } catch (error) {
        debug('gift config parse failed', rawGifts, error.message);
      }

      gifts = gifts.filter(function (gift) {
        return gift && parseInt(gift.variantId, 10) > 0 && parseInt(gift.threshold, 10) > 0;
      }).map(function (gift) {
        return {
          variantId: parseInt(gift.variantId, 10),
          threshold: parseInt(gift.threshold, 10),
          index: parseInt(gift.index, 10) || 1
        };
      });

      if (gifts.length > 0) {
        if (i > 0) debug('use gift config from fallback root index', i, gifts);

        return {
          gifts: gifts
        };
      }
    }

    debug('skip config: no valid gifts in roots', roots.length);
    return null;
  }

  function isGiftLine(item) {
    return item && item.properties && item.properties._cart_free_gift === 'true' && item.properties._cart_free_gift_index;
  }

  function getBaseTotal(cart) {
    var total = cart.items.reduce(function (sum, item) {
      if (isGiftLine(item)) return sum;
      return sum + item.final_line_price;
    }, 0);
    var cartLevelDiscounts = cart.cart_level_discount_applications || [];

    total = total - cartLevelDiscounts.reduce(function (sum, discount) {
      return sum + discount.total_allocated_amount;
    }, 0);

    return Math.max(total, 0);
  }

  function postCart(path, body) {
    if (now() < requestCooldownUntil) {
      return Promise.reject(new Error('Cart request cooldown'));
    }

    return fetch(Shopify.routes.root + path, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) {
        if (response.status === 402 || response.status === 429) {
          requestCooldownUntil = now() + 5000;
        }

        var error = new Error('Cart request failed: ' + path);
        error.status = response.status;
        throw error;
      }

      return response.json();
    });
  }

  function changeLine(id, quantity) {
    return postCart('cart/change.js', { id: id, quantity: quantity });
  }

  function updateLines(lineItems, quantity) {
    var updates = {};

    lineItems.forEach(function (item) {
      updates[item.key] = quantity;
    });

    return postCart('cart/update.js', { updates: updates });
  }

  function addGifts(gifts) {
    return postCart('cart/add.js', {
      items: gifts.map(function (gift) {
        return {
          id: gift.variantId,
          quantity: 1,
          properties: {
            _cart_free_gift: 'true',
            _cart_free_gift_index: String(gift.index)
          }
        };
      })
    });
  }

  async function addMissingGifts(gifts) {
    if (gifts.length === 0) return false;

    debug('try batch add gifts', gifts);

    try {
      await addGifts(gifts);
      debug('batch add gifts success');
      return true;
    } catch (error) {
      debug('batch add gifts failed', error.status || error.message);

      if (error.status === 402 || error.status === 429 || now() < requestCooldownUntil) {
        throw error;
      }
    }

    var added = false;

    for (var i = 0; i < gifts.length; i++) {
      if (now() < requestCooldownUntil) break;

      try {
        await addGifts([gifts[i]]);
        debug('single add gift success', gifts[i]);
        added = true;
      } catch (error) {
        debug('single add gift failed', gifts[i], error.status || error.message);

        if (error.status === 402 || error.status === 429) {
          break;
        }
      }
    }

    return added;
  }

  function refreshCart() {
    var cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer) {
      fetch(Shopify.routes.root + 'cart?section_id=cart-drawer')
        .then(function (response) {
          if (!response.ok) throw new Error('Cart drawer refresh failed');
          return response.text();
        })
        .then(function (html) {
          var nextDocument = new DOMParser().parseFromString(html, 'text/html');
          var nextCartDrawer = nextDocument.querySelector('cart-drawer');
          var currentThreshold = cartDrawer.querySelector('[data-cart-free-gift]');
          var nextThreshold = nextDocument.querySelector('[data-cart-free-gift]');

          if (nextCartDrawer) {
            cartDrawer.classList.toggle('is-empty', nextCartDrawer.classList.contains('is-empty'));
          }

          if (currentThreshold && nextThreshold) {
            currentThreshold.replaceWith(nextThreshold);
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-free-gift' });
          }
        })
        .catch(function (error) {
          debug('drawer refresh failed', error.message);
        });
      return;
    }

    if (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType === 'cart') {
      window.location.reload();
      return;
    }

    suppressRefreshSyncUntil = now() + 1800;
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function refreshCartAfterThemeUpdate() {
    refreshCart();
    window.setTimeout(refreshCart, 1400);
  }

  async function syncGift(cart) {
    var config = getConfig();
    if (!config) {
      debug('skip sync: missing config root');
      return false;
    }

    if (syncing) {
      debug('skip sync: already syncing');
      return false;
    }

    var baseTotal = getBaseTotal(cart);
    var giftLines = cart.items.filter(isGiftLine);
    var nonGiftLines = cart.items.filter(function (item) {
      return !isGiftLine(item);
    });
    var configuredVariantIds = config.gifts.map(function (gift) {
      return gift.variantId;
    });
    var staleGiftLines = giftLines.filter(function (item) {
      return configuredVariantIds.indexOf(item.variant_id) === -1;
    });
    var giftsToAdd = [];
    var giftLinesToRemove = [];
    var changed = false;

    debug('sync start', {
      itemCount: cart.item_count,
      baseTotal: baseTotal,
      nonGiftItemCount: nonGiftLines.length,
      gifts: config.gifts,
      giftLines: giftLines.map(function (item) {
        return {
          key: item.key,
          variantId: item.variant_id,
          quantity: item.quantity,
          index: item.properties && item.properties._cart_free_gift_index
        };
      })
    });

    syncing = true;

    try {
      if (giftLines.length > 0 && nonGiftLines.length === 0) {
        debug('remove gifts because cart has no paid items', giftLines.map(function (item) {
          return item.variant_id;
        }));
        await updateLines(giftLines, 0);
        changed = true;
      } else {
        if (staleGiftLines.length > 0) {
          debug('remove stale gifts', staleGiftLines.map(function (item) {
            return item.variant_id;
          }));
          await updateLines(staleGiftLines, 0);
          changed = true;
        }

        for (var j = 0; j < config.gifts.length; j++) {
          var gift = config.gifts[j];
          var qualifies = baseTotal >= gift.threshold;
          var currentGiftLines = giftLines.filter(function (item) {
            return item.variant_id === gift.variantId;
          });

          if (!qualifies) {
            for (var k = 0; k < currentGiftLines.length; k++) {
              debug('remove unqualified gift', gift.variantId, 'threshold', gift.threshold, 'baseTotal', baseTotal);
              giftLinesToRemove.push(currentGiftLines[k]);
            }
          } else if (currentGiftLines.length === 0) {
            debug('missing qualified gift', gift.variantId, 'threshold', gift.threshold, 'baseTotal', baseTotal);
            giftsToAdd.push(gift);
          } else {
            for (var l = 0; l < currentGiftLines.length; l++) {
              if (currentGiftLines[l].quantity !== 1 || l > 0) {
                debug('normalize gift quantity', gift.variantId, currentGiftLines[l].quantity, l);
                if (l === 0) {
                  await changeLine(currentGiftLines[l].key, 1);
                  changed = true;
                } else {
                  giftLinesToRemove.push(currentGiftLines[l]);
                }
              }
            }
          }
        }

        if (giftLinesToRemove.length > 0) {
          await updateLines(giftLinesToRemove, 0);
          changed = true;
        }

        if (giftsToAdd.length > 0) {
          changed = await addMissingGifts(giftsToAdd) || changed;
        }
      }
    } finally {
      syncing = false;
    }

    if (changed) {
      debug('sync changed cart, refresh and verify');
      refreshCartAfterThemeUpdate();
      scheduleVerifySync();
    } else {
      debug('sync no change needed');
      verifyRetryCount = 0;
    }

    if (pendingSync) {
      debug('run pending sync');
      pendingSync = false;
      scheduleFetchCartAndSync(100);
    }

    return changed;
  }

  function fetchCartAndSync(options) {
    options = options || {};
    syncTimer = null;

    if (now() < requestCooldownUntil) {
      debug('skip fetch: request cooldown');
      return Promise.resolve(false);
    }

    if (syncing) {
      debug('queue pending sync while syncing');
      pendingSync = true;
      return Promise.resolve(false);
    }

    if (!getConfig()) {
      debug('skip fetch: missing config root');
      return Promise.resolve(false);
    }

    debug('fetch cart and sync', options);

    return fetch(Shopify.routes.root + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) {
          if (response.status === 402 || response.status === 429) {
            requestCooldownUntil = now() + 5000;
          }

          debug('cart fetch failed', response.status);
          throw new Error('Cart fetch failed');
        }

        return response.json();
      })
      .then(function (cart) {
        return syncGift(cart);
      })
      .catch(function (error) {
        debug('fetch/sync failed', {
          options: options,
          status: error && error.status,
          message: error && error.message
        });

        if (options.retryOnFailure && fallbackRetryCount < 3 && now() >= requestCooldownUntil) {
          fallbackRetryCount += 1;
          debug('schedule fallback retry', fallbackRetryCount);
          window.setTimeout(function () {
            fetchCartAndSync({ retryOnFailure: true });
          }, fallbackRetryCount * 1200);
        }

        return false;
      });
  }

  function scheduleFetchCartAndSync(delay) {
    if (syncTimer) {
      window.clearTimeout(syncTimer);
    }

    debug('schedule sync', delay || 150);
    syncTimer = window.setTimeout(fetchCartAndSync, delay || 150);
  }

  function scheduleCartPayloadSync(cart, delay) {
    if (!cart || !cart.items) {
      scheduleFetchCartAndSync(delay || 100);
      return;
    }

    if (cartPayloadSyncTimer) {
      window.clearTimeout(cartPayloadSyncTimer);
    }

    debug('schedule payload sync', delay || 0);
    cartPayloadSyncTimer = window.setTimeout(function () {
      cartPayloadSyncTimer = null;

      if (syncing) {
        debug('queue pending payload sync while syncing');
        pendingSync = true;
        return;
      }

      syncGift(cart).catch(function (error) {
        debug('payload sync failed', {
          status: error && error.status,
          message: error && error.message
        });

        fetchCartAndSync({ retryOnFailure: true });

        if (fallbackRetryCount < 3 && now() >= requestCooldownUntil) {
          fallbackRetryCount += 1;
          window.setTimeout(function () {
            fetchCartAndSync({ retryOnFailure: true });
          }, fallbackRetryCount * 500);
        }
      });
    }, delay || 0);
  }

  function scheduleVerifySync() {
    if (verifyRetryCount >= 3 || now() < requestCooldownUntil) return;

    verifyRetryCount += 1;
    debug('schedule verify sync', verifyRetryCount);
    window.setTimeout(function () {
      fetchCartAndSync({ retryOnFailure: true });
    }, 900 * verifyRetryCount);
  }

  document.addEventListener('cart:change', function (event) {
    if (event.detail && event.detail.baseEvent === 'cart-free-gift:change') {
      return;
    }

    scheduleCartPayloadSync(event.detail && event.detail.cart, 20);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'cart-free-gift') return;
      scheduleFetchCartAndSync(100);
    });
  }

  document.addEventListener('line-item:change', function (event) {
    scheduleCartPayloadSync(event.detail && event.detail.cart, 50);
    window.setTimeout(function () {
      scheduleFetchCartAndSync(100);
    }, 700);
  });

  document.addEventListener('click', function (event) {
    var removeLink = event.target.closest && event.target.closest('line-item-quantity a[href*="/cart/change"]');
    var lineItem = removeLink && removeLink.closest('line-item');
    if (!removeLink || lineItem && lineItem.querySelector('.cart-free-gift-badge')) return;

    debug('paid item remove clicked');
    scheduleFetchCartAndSync(800);
  }, true);

  document.addEventListener('cart:refresh', function () {
    if (now() < suppressRefreshSyncUntil) return;

    scheduleFetchCartAndSync(250);
  });

  function runFallbackSync() {
    if (now() - lastFallbackSyncAt < 1000) return;

    lastFallbackSyncAt = now();
    fallbackRetryCount = 0;
    debug('run page fallback sync');
    scheduleFallbackSweep();
  }

  function scheduleFallbackSweep() {
    [120, 700, 2000, 5000].forEach(function (delay) {
      window.setTimeout(function () {
        debug('fallback sweep check', delay);
        fetchCartAndSync({ retryOnFailure: true });
      }, delay);
    });
  }

  function watchGiftConfigRoots() {
    if (watchingGiftConfigRoots || !window.MutationObserver || !document.body) return;

    watchingGiftConfigRoots = true;
    observedGiftRootCount = document.querySelectorAll('[data-cart-free-gift]').length;

    new MutationObserver(function (mutations) {
      var rootCount = document.querySelectorAll('[data-cart-free-gift]').length;
      var changedConfig = rootCount !== observedGiftRootCount;

      if (!changedConfig) {
        changedConfig = mutations.some(function (mutation) {
          return mutation.type === 'attributes' && mutation.target && mutation.target.matches && mutation.target.matches('[data-cart-free-gift]');
        });
      }

      if (!changedConfig) return;

      observedGiftRootCount = rootCount;
      debug('gift config roots changed', rootCount);
      scheduleFetchCartAndSync(300);
    }).observe(document.body, {
      attributes: true,
      attributeFilter: ['data-gifts'],
      childList: true,
      subtree: true
    });
  }

  function init() {
    runFallbackSync();
    watchGiftConfigRoots();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('pageshow', runFallbackSync);
  window.cartFreeGiftSync = function () {
    fallbackRetryCount = 0;
    debug('manual sync requested');
    return fetchCartAndSync({ retryOnFailure: true });
  };
})();
